import React from "react";

import '../styles/footer.scss';

const Footer = () => {
    return (
        <div className="child-footer">
            Copyright © 2022   ARC Adoption North East - All Rights Reserved
        </div>
    );
}

export default Footer;
